<template>
  <div class="drink-store-create">
    <div class="drink-store-create-container">
      <div class="drink-store-create-operate">
        <p class="drink-store-create-operate-title">{{$t('xin_zeng_yin_pin_pei_fang')}}</p>
        <div class="drink-store-create-operate-content">
          <el-form ref="form" label-width="auto" size="mini">
            <el-form-item :label="$t('xuan_qu_she_bei')">
              <el-select v-model="drinkSync.deviceUuid" :placeholder="$t('qing_xuan_qu_fu_zhi_she_bei')"
                         filterable @change="loadDrink">
                <el-option :label="device.deviceName" :value="device.deviceUuid" v-for="device in devices"/>
              </el-select>
              <el-button size="mini" type="primary" style="margin-left: 20px" @click="load">{{$t('jia_zai_she_bei')}}</el-button>
            </el-form-item>
            <el-col :span="10">
              <el-form-item :label="$t('pei_fang_ming_cheng')">
                <el-input v-model="drinkSync.taskName"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item :label="$t('xuan_qu_yin_pin')" size="mini" :disable="drinkDisable">
                <el-transfer
                  :titles="[$t('yin_pin_lie_biao'), $t('yi_xuan_yin_pin')]"
                  filterable
                  :filter-method="filterMethod"
                  :filter-placeholder="$t('qing_shu_ru_yin_pin_ming_cheng')"
                  v-model="drinkSync.drinkUuid"
                  :data="drinks">
                </el-transfer>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item>
                <el-button type="primary" size="small" @click="handleDrinkSyncCreate">{{$t('ti_jiao')}}</el-button>
                <el-button @click="goBack" size="small">{{$t('fan_hui')}}</el-button>
              </el-form-item>
            </el-col>

          </el-form>
        </div>

      </div>
      <div class="drink-store-create-info">
        <p class="drink-store-create-operate-title">{{$t('xin_zeng_cao_zuo_shuo_ming')}}</p>
        <ol class="drink-store-create-info-content">
          <li class="alarm">{{$t('qing_que_bao_xuan_qu_she_bei_zai_xian')}}</li>
          <li>{{$t('xuan_qu_zai_xian_she_bei')}}</li>
          <li>{{$t('tian_ru_pei_fang_ming_cheng')}}</li>
          <li>{{$t('xuan_qu_pei_fang_zhong_bao_han_de_yin_pin')}}</li>
          <li>{{$t('deng_dai_xi_tong_wan_cheng_she_bei_yin_pin_du_qu')}}</li>
        </ol>
      </div>
      <loading :show="showLoading" :text="$t('zheng_zai_huo_qu_she_bei_yin_pin')"/>
    </div>
  </div>

</template>

<script>

  import {deviceOnline, deviceDrink, deviceCtrlDrinkParamUpload} from '@/api/delivery/device/drink'
  import {checkObj} from "@/util/checkLogin";
  import {randomNum} from "@/util/random";
  import Loading from '@/components/Loading'

  import {drinkSyncParam} from '@/api/delivery/device/drink'

  export default {
    name: '',
    components: {
      Loading
    },
    mounted: function () {
      this.load()

    },
    data: function () {
      return {
        devices: [],
        drinkDisable: true,
        checkDrinks: [],
        drinks: [],
        showLoading: false,
        drinkSync: {
          uuid: '',
          deviceUuid: '',
          taskName: '',
          imgIndex: 0,
          drinkUuid: [],
        },
      }
    },
    methods: {
      load() {
        deviceOnline().then(res => {
          this.devices = res.data || []
          if (this.devices.length === 0) {
            this.$router.back()
            return
          }
          let drinkSync = this.$route.params.drink
          if (drinkSync) {
            this.drinkSync.deviceUuid = drinkSync.deviceUuid
            this.drinkSync.taskName = drinkSync.name
            this.drinkSync.imgIndex = drinkSync.imgIndex
            this.drinkSync.drinkUuid = drinkSync.drinkUuid.split(",")
            this.drinkSync.uuid = drinkSync.uuid
            this.loadDrink(drinkSync.deviceUuid, this.drinkSync.drinkUuid)
          }
        })
      },
      loadDrink(val, drinkUuid = []) {
        this.drinkSync.drinkUuid = drinkUuid
        let vue = this
        deviceDrink({uuid: val}).then(res => {
          let drinks = res.data || []
          drinks.forEach(item => {
            vue.drinks.push({
              key: item.drinkUuid,
              label: item.name,
            })
          })
        })
      },

      handleDrinkSyncCreate() {
        let check = checkObj(this.drinkSync, [
          {value: 'deviceUuid', message: this.$t('qing_xuan_qu_she_bei')},
          {value: 'taskName', message: this.$t('qing_shu_ru_pei_fang_ming')},
        ])

        if (!check.status) {
          this.$message.warning(check.message)
          return
        }

        if (this.drinkSync.drinkUuid.length === 0) {
          this.$message.warning(this.$t('qing_xuan_qu_yin_pin'))
          return
        }
        this.drinkSync.imgIndex = randomNum(0, 14)
        deviceCtrlDrinkParamUpload(this.drinkSync).then(res => {
          this.$message.success(this.$t('chuang_jian_cheng_gong'))
          this.showLoading = true
          this.queryDrinkSync(res.data)
        })
      },

      queryDrinkSync(uuid) {
        let vue = this
        setTimeout(function () {
          drinkSyncParam({uuid: uuid}).then(res => {
            let drinks = res.data || []
            if (!drinks) {
              return;
            }
            vue.showLoading = false
            vue.$router.replace({name: 'delivery.devices.drinkSort.edit', params: {uuid: uuid, drink: drinks}})
          })
        }, 5 * 1000)
      },
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      goBack() {
        this.$router.back()
      },

    },
  }
</script>

<style lang="scss">
  .drink-store-create {

    .drink-store-create-container {
      display: flex;
      width: 90%;
      @media screen and (max-width: 1440px) {
        width: 64%;
      }
      margin: 0 auto;

      flex: none;

      .el-transfer-panel {
        background: #393c42;
      }

      .el-transfer-panel__filter {
        text-align: center;
        margin: 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        display: block;
        width: auto !important;
      }

      .el-transfer-panel .el-checkbox__label {
        padding-left: 24px !important;
      }

      .el-transfer__buttons {
        display: inline-block;
        vertical-align: middle;
        padding: 0 30px;

        .el-transfer__button {
          display: block;
          padding: 10px;
          border-radius: 50%;
          margin: 0 auto;
          font-size: 0;
        }

        .el-transfer__button:first-child {
          margin-bottom: 10px;
        }

      }


      .el-transfer-panel .el-transfer-panel__header {
        background: #393c42;
      }

      .el-transfer-panel .el-transfer-panel__header .el-checkbox {
        display: block;
        line-height: 40px
      }

      .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
        font-size: 16px;
        color: #bbbfc7;
        font-weight: 400
      }

      .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label span {
        position: absolute;
        right: 15px;
        color: #666;
        font-size: 12px;
        font-weight: 400
      }

      .el-transfer-panel__filter .el-input__inner {
        border-radius: 0;
        border-bottom: 1px solid #615e5e;
      }

      .drink-store-create-operate-title {
        font-weight: 500;
        margin-bottom: 20px;
        height: 20px;
        line-height: 20px;
      }

      .drink-store-create-operate {
        flex: 1;

        padding: $padding;
        display: flex;
        flex-direction: column;

        .drink-store-create-operate-content {
          flex: 1;
          display: -webkit-box;
          -webkit-box-orient: horizontal;
          -webkit-box-pack: center;
          -webkit-box-align: start;

          display: -moz-box;
          -moz-box-orient: horizontal;
          -moz-box-pack: center;
          -moz-box-align: center;
        }
      }

      .drink-store-create-info {
        width: 24%;
        border: 1px solid #82858b;
        padding: $padding;
        margin-left: 20px;
        border-radius: 16px;
      }

      .drink-store-create-info-content {
        font-size: 12px;
        list-style-type: none;
        counter-reset: sectioncounter;

        li {
          line-height: 1.5;
        }

        li:before {
          content: counter(sectioncounter) "、";
          counter-increment: sectioncounter;
        }
      }

      .drink-store-edit-content {
        padding: 0 $padding $padding $padding;

        .el-input-number__increase, .el-input-number__decrease {
          border-color: #D8DDE3;
        }
      }

      .alarm {
        color: $btn_color;
      }

      .error {
        color: $btn_sec_color !important;
      }

      .el-tag + .el-tag {
        margin-left: 10px;
      }

      .drink-store-edit-item {
        margin-bottom: $padding;

        .drink-store-edit-item-title {
          margin-bottom: $padding;

          span {
            float: right;
            font-size: 12px;
            display: inline-block;


            i {
              font-size: 14px;
            }
          }
        }

        .drink-store-edit-item-content {
          padding: $padding;
          background-color: #b2bfc8;
        }

        .drink-height {
          height: 240px;
          overflow-y: scroll;
        }
      }

      .delete-drink-store {

        i {
          font-size: 14px;
        }
      }
    }
  }

</style>
